"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const SortFilter = _ref => {
  let {
    title = 'Sort & Filter',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-367 -76) translate(24 66) translate(343 10)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M6,4.99000269 L6,1.19289282 C6,0.533758577 5.55288,0 4.99926,0 C4.44712,0 4,0.533758577 4,1.19289282 L4,5.09752241 M4,13.2112074 L4,30.8071072 C4,31.4662414 4.44712,32 4.99926,32 C5.55288,32 6,31.4662414 6,30.8071072 L6,13.1792075",
    id: "shape_1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M10,9.5 C10,6.46334 7.7604,4 5,4 C2.2394,4 0,6.46312 0,9.5 C0,12.53688 2.2396,15 5,15 C7.7606,15 10,12.53688 10,9.5 Z M2.2258,9.5 C2.2258,7.816252 3.4683,6.45234 4.9998,6.45234 C6.53122,6.45234 7.7738,7.81623 7.7738,9.5 C7.7738,11.18377 6.5313,12.54766 4.9998,12.54766 C3.46838,12.54766 2.2258,11.18377 2.2258,9.5 Z",
    id: "shape_2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M28,4.99000269 L28,1.19289282 C28,0.533758577 27.55288,0 27.00074,0 C26.44712,0 26,0.533758577 26,1.19289282 L26,5.09752241 M26,13.2112074 L26,30.8071072 C26,31.4662414 26.44712,32 27.00074,32 C27.55288,32 28,31.4662414 28,30.8071072 L28,13.1792075",
    id: "shape_3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M32,9.5 C32,6.46334 29.7622,4 27,4 C24.2394,4 22,6.46312 22,9.5 C22,12.53688 24.2396,15 27,15 C29.7622,15 32,12.53688 32,9.5 Z M24.2274,9.5 C24.2274,7.816252 25.46822,6.45234 26.9996,6.45234 C28.5327,6.45234 29.7736,7.81623 29.7736,9.5 C29.7736,11.18377 28.53278,12.54766 26.9996,12.54766 C25.46818,12.54766 24.2274,11.18377 24.2274,9.5 Z",
    id: "shape_4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M16,27.0099973 L16,30.8071072 C16,31.4662414 16.44712,32 16.99926,32 C17.55288,32 18,31.4662414 18,30.8071072 L18,26.9024776 M18,18.7887926 L18,1.19289282 C18,0.533758577 17.55288,0 16.99926,0 C16.44712,0 16,0.533758577 16,1.19289282 L16,18.8207925",
    id: "shape_5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M12,22.5 C12,25.53666 14.2378,28 17,28 C19.7606,28 22,25.53688 22,22.5 C22,19.46312 19.7604,17 17,17 C14.2378,17 12,19.46312 12,22.5 Z M19.7726,22.5 C19.7726,24.183748 18.53178,25.54766 17.0004,25.54766 C15.4673,25.54766 14.2264,24.18377 14.2264,22.5 C14.2264,20.816208 15.46722,19.45234 17.0004,19.45234 C18.53182,19.45234 19.7726,20.81623 19.7726,22.5 Z",
    id: "shape_6"
  })));
};
var _default = exports.default = (0, _ikon.default)(SortFilter);
SortFilter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SortFilter",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Sort & Filter'",
        "computed": false
      },
      "required": false
    }
  }
};